import React, { Fragment } from 'react'
import { Link } from 'gatsby'

import * as styles from './Breadcrumbs.module.scss'

import { Icon } from '@iconify/react'

const Breadcrumbs = ({ breadcrumbs }) => {
  let content = breadcrumbs.map((breadcrumb, idx) => {
    let urlStr = `/${breadcrumb
      .replace('&', '')
      .replace(/\s+/g, '-')
      .toLowerCase()}`
    return (
      <span className={styles.breadcrumb_wrap} key={idx}>
        <span className={styles.breadcrumb_divider}>
          <Icon icon="eva:arrow-ios-forward-fill" inline={true} />
        </span>
        {breadcrumb !== 'Capabilities' ? (
          <Link to={urlStr} className={styles.breadcrumb_link}>
            {breadcrumb}
          </Link>
        ) : (
          <Fragment>{breadcrumb}</Fragment>
        )}
      </span>
    )
  })

  return (
    <Fragment>
      <Link to="/" className={styles.breadcrumb_link}>
        <span className={styles.breadcrumb_backButton}>
          <Icon icon="akar-icons:arrow-left" inline={true} />
        </span>
        Home
      </Link>
      {content}
    </Fragment>
  )
}

export default Breadcrumbs
